import script from "./CommerceB2bPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceB2bPricing.vue?vue&type=script&setup=true&lang=js"

import "./CommerceB2bPricing.vue?vue&type=style&index=0&id=046c7824&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046c7824"]])

export default __exports__